// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pour les espaces vides qui maintiennent la structure de la grille */
.placeholder-group {
  min-height: 1px;
}

.radio-options {
  margin-top: 0.5rem;
}

.date-input {
  width: 100%;
}

/* Styles pour le mode consultation */
.view-mode {
  padding: 0;
}

.view-mode .form-group {
  margin-bottom: 2rem;
}

.view-mode label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.5rem;
  color: #2c3948;
}

.step-container .form-subtitle {
  font-size: 1.2rem;
  color: #6b7280;
  font-style: italic;
  margin-left: 0.5rem;
}

.radio-options {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}

.radio-options label {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
}

.radio-options input[type="radio"] {
  width: 1.6rem;
  height: 1.6rem;
  margin: 0;
}
/*
.bc-fixed-delay {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  border: 1px solid #e9ecef !important;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  font-style: italic;
} */

/* .bc-fixed-delay span {
  font-size: 0.9rem;
} */

.desc-precision {
  display: block;
  margin: 2rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/composants/FormulaireAdministratif/FormulaireAdministratif.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;AACA;;;;;;;;GAQG;;AAEH;;GAEG;;AAEH;EACE,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* Pour les espaces vides qui maintiennent la structure de la grille */\n.placeholder-group {\n  min-height: 1px;\n}\n\n.radio-options {\n  margin-top: 0.5rem;\n}\n\n.date-input {\n  width: 100%;\n}\n\n/* Styles pour le mode consultation */\n.view-mode {\n  padding: 0;\n}\n\n.view-mode .form-group {\n  margin-bottom: 2rem;\n}\n\n.view-mode label {\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #2c3948;\n}\n\n.step-container .form-subtitle {\n  font-size: 1.2rem;\n  color: #6b7280;\n  font-style: italic;\n  margin-left: 0.5rem;\n}\n\n.radio-options {\n  display: flex;\n  gap: 2rem;\n  margin-top: 1rem;\n}\n\n.radio-options label {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  cursor: pointer;\n}\n\n.radio-options input[type=\"radio\"] {\n  width: 1.6rem;\n  height: 1.6rem;\n  margin: 0;\n}\n/*\n.bc-fixed-delay {\n  background-color: #f8f9fa !important;\n  color: #6c757d !important;\n  border: 1px solid #e9ecef !important;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  font-style: italic;\n} */\n\n/* .bc-fixed-delay span {\n  font-size: 0.9rem;\n} */\n\n.desc-precision {\n  display: block;\n  margin: 2rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
